import React from 'react';

export const NFCDevEnvInfo = () => (
    <code>
        This is development environment and this browser does not support NFC scanning. For development purposes, a
        manual input fields are visible.
    </code>
);
